import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";

//************************   Company ****************************************** */
export const getCompany = async() =>{
    const result = await PrivateInterceptor(`Base/proveedores/Company`, 'GET')
    return result
}

export const postCompany = async(datos) =>{
    
    const result = await PrivateInterceptor(`Base/proveedores/Company`, 'POST', datos)
    return result
}

export const getAllCompany = async() =>{
    const result = await PrivateInterceptor(`Base/proveedores/Company/ALL`, 'GET')
    return result
}

export const getInfoCompany = async() =>{
    const result = await PrivateInterceptor(`Base/proveedores/Company/infoCompany`, 'GET')
    return result
}

export const getCompanyCustomer = async(IdCompany) =>{
    const result = await PrivateInterceptor(`Base/proveedores/Company/${IdCompany}`, 'GET')
    return result
}

export const getProveedoresVarios = async() =>{
    const result = await PrivateInterceptor(`Base/proveedores/varios`, 'GET')
    return result
}


export const getHistoricoHexonerados = async(IdProveedor) =>{
    const result = await PrivateInterceptor(`Base/proveedores/HistoricosExonerados/${IdProveedor}`, 'GET')
    return result
};

